import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NavService } from '../../../_services/_nav.service';
import { TranslateService } from '@ngx-translate/core';
import { Table } from 'primeng/table';
import { AdministradorDocumento } from '../../../_models/administrador-documento';
import { AdministradorDocumentoService } from '../../../_services/administrador-documento.service';

@Component({
  moduleId: module.id,
  templateUrl: './administration-documents.component.html',
  selector: 'administration-documents-component'
})
export class AdministrationDocumentsComponent implements OnInit {
   @Input() listValidityDocuments: AdministradorDocumento[] = [];
   @ViewChild('dt', { static: true }) tabla: Table;
   busqueda: string;
   columnas: any[] = [];
   carTabla: boolean = false;

   constructor( private router: Router,
                private _nav: NavService,
                private translateService: TranslateService,
                private administradorDocumentoService: AdministradorDocumentoService
               ) {
      this.busqueda = _nav.getSearch( 'document-management' );

   }

   ngOnInit(): void {
      this.setEncabezadoTable();
   }

   async setEncabezadoTable(){
      this.columnas = [
         { field: 'codigo', header: await this.translateService.get( 'VIGENCIADEDATOS.LBL_CODIGO' ).toPromise(), sort: false },
         { field: 'nombre', header: await this.translateService.get( 'VIGENCIADEDATOS.LBL_NOMBREDOCUMENTO' ).toPromise(), sort: false },
         { field: 'descripcion', header: await this.translateService.get( 'VIGENCIADEDATOS.LBL_DESCRIPCION' ).toPromise(), sort: false },
         { field: 'tipoVigencia', header: await this.translateService.get( 'VIGENCIADEDATOS.LBL_TIPOVIGENCIA' ).toPromise(), sort: false },
         { field: 'duracionVigencia', header: await this.translateService.get( 'VIGENCIADEDATOS.LBL_VIGENCIA' ).toPromise(), sort: false },
         { field: 'orden', header: await this.translateService.get( 'LBL_ORDEN' ).toPromise(), sort: false },
         { field: 'indicadorHabilitado', header: await this.translateService.get( 'VIGENCIADEDATOS.LBL_HABILITADO' ).toPromise(), sort: false },
         { field: 'indicadorTercero', header: await this.translateService.get( 'VIGENCIADEDATOS.LBL_TERCERO' ).toPromise(), sort: false },
         { field: 'indicadorSolicitarCliente', header: await this.translateService.get( 'VIGENCIADEDATOS.LBL_SOLICITARCLIENTE' ).toPromise(), sort: false },
         { field: 'acciones', header: await this.translateService.get( 'VIGENCIADEDATOS.LBL_ACCIONES' ).toPromise(), sort: false },
      ];
   }

   add(){
      this.router.navigate([`/apl/vigencias/administration-documents-add`]);
   }

   detail(row: AdministradorDocumento){
      this.router.navigate([`/apl/vigencias/administration-documents-detail/${row.idDocumentoTercero }`]);
   }

   edit(row: AdministradorDocumento){
      this.router.navigate([`/apl/vigencias/administration-documents-edit/${row.idDocumentoTercero }`]);
   }

   setSearch() {
      this._nav.setSearch( 'document-management', this.busqueda );
   }

   async consulta() {
      this.administradorDocumentoService.getAll().subscribe(listado => {
        this.listValidityDocuments = listado.sort((a, b) => a.orden - b.orden);
        this.tabla.filterGlobal(this.busqueda, 'contains');
      });
    }

    async cambiarOrden(item: any, subir: boolean) {
      this.carTabla = true;
      const currentIndex = this.listValidityDocuments.findIndex(doc => doc.id === item.id);
      
      if ((subir && currentIndex === 0) || 
          (!subir && currentIndex === this.listValidityDocuments.length - 1)) {
            this.carTabla = false;
        return;
      }
    
      const targetIndex = subir ? currentIndex - 1 : currentIndex + 1;
      const currentItem = { ...this.listValidityDocuments[currentIndex] };
      const targetItem = { ...this.listValidityDocuments[targetIndex] };
    
      const tempOrden = currentItem.orden;
      currentItem.orden = targetItem.orden;
      targetItem.orden = tempOrden;
    
      try {
        await this.administradorDocumentoService.bulk([currentItem, targetItem]).toPromise();
        await this.consulta();
        this.carTabla = false;
      } catch (error) {
        console.error('Error al actualizar el orden:', error);
        this.carTabla = false;
      }
    }
}
